<template>
    <div class="column-toggle-container">
        <div class="column-toggle-header">
            <div class="title">Select Column</div>
            <div class="view-all">
                <input type="checkbox" id="view-all" v-model="viewAll" @change="toggleAll" />
                <label for="view-all">View All</label>
            </div>
        </div>
        <div class="column-toggle-body">
            <div class="column-grid">
                <div v-for="(column, index) in availableColumns" :key="column.key" class="column-item">
                    <input type="checkbox" :id="`column-${column.key}`" v-model="selectedColumnsMap[column.key]" />
                    <label :for="`column-${column.key}`">{{ column.label }}</label>
                </div>
            </div>
            <div v-if="isSaving" class="saving-indicator">
                Saving preferences...
            </div>
        </div>
    </div>
</template>

<script>


export default {
    name: 'WidgetTableColumnToggle',
    props: {
        tableType: {
            type: String,
            required: true
        },
        availableColumns: {
            type: Array,
            required: true,
            default: () => []
        },
    },
    data() {
        return {
            selectedColumnsMap: {},
            viewAll: false,
            isSaving: false
        }
    },
    created() {
        this.loadSavedColumns()
    },
    watch: {
        selectedColumnsMap: {
            handler(newVal) {
                const selected = Object.keys(newVal).filter(key => newVal[key])
                this.viewAll = selected.length === Object.keys(newVal).length && Object.keys(newVal).length > 0
                this.$emit('input', selected)
                this.saveColumnPreferences(selected)
            },
            deep: true
        }
    },
    methods: {
        toggleAll() {
            const selectedColumnsMap = { ...this.selectedColumnsMap }

            Object.keys(selectedColumnsMap).forEach(key => {
                selectedColumnsMap[key] = this.viewAll
            })

            this.selectedColumnsMap = selectedColumnsMap
        },
        loadSavedColumns() {
            let vm = this;
            vm.$store
                .dispatch("GET_TABLE_PREFERENCES", {
                    tableType: this.tableType,
                    availableColumns: this.availableColumns.map(col => col.key)
                }).then((response) => {
                    const columns = JSON.parse(response.data.columns);
                    // Only apply saved columns that are available in the current table
                    const validColumns = columns.filter(col =>
                        this.availableColumns.some(availCol => availCol.key === col)
                    )


                    if (validColumns.length > 0) {
                        // Update the selected columns
                        const selectedColumnsMap = {}
                        this.availableColumns.forEach(col => {
                            selectedColumnsMap[col.key] = validColumns.includes(col.key)
                        })
                        this.selectedColumnsMap = selectedColumnsMap;
                        this.$emit('input', validColumns)
                    }

                }).catch((error) => {
                    console.error('Error loading saved columns:', error)
                });

        },
        saveColumnPreferences(selectedColumns) {
            let vm = this;
            if (vm.saveTimeout) {
                clearTimeout(vm.saveTimeout)
            }

            vm.saveTimeout = setTimeout(async () => {
                if (vm.isSaving) return
                vm.isSaving = true;
                vm.$store
                    .dispatch("SAVE_TABLE_PREFERENCES", {
                        tableType: this.tableType,
                        columns: selectedColumns
                    })
                    .then((response) => {

                    })
                    .catch((error) => {
                        console.error('Error saving column preferences:', error)
                    })
                    .finally(() => {
                        vm.isSaving = false
                    })
            }, 500)
        }
    }
}
</script>

<style lang="scss" scoped>
.column-toggle-container {
    width: 100%;
    max-width: 600px;
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    padding: 16px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;

    .column-toggle-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;

        .title {
            font-size: 12px;
            color: #000000;
            font-weight: 500;
        }

        .view-all {
            display: flex;
            align-items: center;

            input[type="checkbox"] {
                width: 14px;
                height: 14px;
                border: 1px solid #cbd5e0;
                border-radius: 3px;
                margin-right: 6px;
                appearance: none;
                -webkit-appearance: none;
                -moz-appearance: none;
                position: relative;
                cursor: pointer;
                outline: none;

                &:checked {
                    background-color: #000000;
                    border-color: #000000;

                    &::after {
                        content: '';
                        position: absolute;
                        left: 4px;
                        top: 1px;
                        width: 3px;
                        height: 7px;
                        border: solid white;
                        border-width: 0 1px 1px 0;
                        transform: rotate(45deg);
                    }
                }
            }

            label {
                font-size: 12px;
                color: #000000;
                cursor: pointer;
            }
        }
    }

    .column-toggle-body {
        display: flex;
        flex-direction: column;
        gap: 14px;

        .column-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 12px;

            .column-item {
                display: flex;
                align-items: center;

                input[type="checkbox"] {
                    width: 14px;
                    height: 14px;
                    border: 1px solid #cbd5e0;
                    border-radius: 3px;
                    margin-right: 6px;
                    appearance: none;
                    -webkit-appearance: none;
                    -moz-appearance: none;
                    position: relative;
                    cursor: pointer;
                    outline: none;

                    &:checked {
                        background-color: #000000;
                        border-color: #000000;

                        &::after {
                            content: '';
                            position: absolute;
                            left: 4px;
                            top: 1px;
                            width: 3px;
                            height: 7px;
                            border: solid white;
                            border-width: 0 1px 1px 0;
                            transform: rotate(45deg);
                        }
                    }
                }

                label {
                    font-size: 12px;
                    color: #000000;
                    cursor: pointer;
                }
            }
        }

        .saving-indicator {
            font-size: 11px;
            color: #718096;
            text-align: right;
            margin-top: 8px;
            font-style: italic;
        }
    }
}
</style>